export const chart_theme_orange_ColorScale_500 = {
  "name": "--pf-chart-theme--orange--ColorScale--500",
  "value": "#c46100",
  "var": "var(--pf-chart-theme--orange--ColorScale--500, #c46100)"
};
export default chart_theme_orange_ColorScale_500;